import { useCallback } from 'react';
import { useRouter } from 'next/router';

import '../../../consts/events.quiz-detail-cta';

import { trackEvent } from '@zep/logger/tracking';

import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
interface UseEditHandlerParams {
  quizId: string;
  quizData: QuizSetDetailsRes;
}

/**
 * useEditHandler - 수정하기 핸들러
 *
 * @description
 * 퀴즈 수정 페이지로 이동합니다.
 */
export const useEditHandler = ({ quizId, quizData }: UseEditHandlerParams) => {
  const router = useRouter();

  return useCallback(() => {
    void router.push({
      pathname: `/update/${quizId}`,
    });
    trackEvent('enter_update', {
      location: 'detail',
      spaceId: quizData.id,
      is_locked: quizData.isLocked,
    });
  }, [router, quizId, quizData]);
};
